import { mobileAccess, virtualDir } from "#skyward_global";
import { getLayerFromElement, ModalDialogSettings, showDialog } from "#skyward_modalLayer";
import { registerEvents } from "./skyward.ui.events";

const events =
{
    clearCaches,
    toggleMobileSession
};

registerEvents("support", events);

export function build()
{
    const options: ModalDialogSettings =
    {
        draggable: true,
        closeOnClick: false,
        dynamicDialogContentSelector: ".supportTools"
    };

    const contentPromise = $.ajax(
    {
        url: `${virtualDir}SkySys/Support/SupportTools?renderType=contentOnly`,
        method: "GET",
        dataType: "viewpartHtml"
    });

    showDialog("Support Tools", contentPromise, [], options);
}

function clearCaches(this: HTMLElement)
{
    getLayerFromElement(this)?.close();

    const contentPromise = $.ajax(
    {
        url: `${virtualDir}SkySys/CacheVersion/ClearCaches?renderType=contentOnly`,
        method: "GET",
        dataType: "viewpartHtml",
    });

    showDialog("Clear Caches", contentPromise);
}

async function toggleMobileSession()
{
    await $.ajax(
    {
        url: `${virtualDir}Security/Session/MobileSession`,
        type: "PATCH",
        data:
        {
            toggle: !mobileAccess
        }
    });

    window.location.reload();
}
